module.exports = __webpack_public_path__ + "assets/15942302ef9a54cf00e9f4911f7ae4a8.json";